export enum ExportByUnit {
  ASSET_UNIT = 2,
  ASSET_CATEGORY = 1,
}
